module.exports = __webpack_public_path__ + "img/Dashboard copy.dfd0465b.svg";